// Tables: wrap for horizontal scroll, detect numeric columns, optional sorting,
// and turn a following "Table: ..." paragraph into a numbered caption.
const SORT_ICON = '<svg class="ci" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M8 4.75v14.5M8 4.75 4.75 8M8 4.75 11.25 8M16 19.25V4.75M16 19.25 19.25 16M16 19.25 12.75 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const numeric = (s) => /^[-+]?[$€£]?\s?[\d,]*\.?\d+\s?%?$/.test(String(s).trim()) && String(s).trim() !== "";
const toNumber = (s) => parseFloat(String(s).replace(/[^0-9.+-]/g, ""));

export default function tables() {
    const content = document.querySelector(".gh-content");
    if (!content) return;

    content.querySelectorAll("table").forEach((table) => {
        if (table.closest(".gh-table-wrap, .viz-data")) return;

        // wrap
        const wrap = document.createElement("div");
        wrap.className = "gh-table-wrap";
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);

        // caption from the paragraph that follows: "Table: Failures by year"
        const next = wrap.nextElementSibling;
        if (next && next.tagName === "P" && /^table\s*[:.]\s*/i.test(next.textContent)) {
            const cap = document.createElement("div");
            cap.className = "gh-table-caption";
            cap.innerHTML = next.innerHTML.replace(/^\s*(<em>|<strong>)?\s*table\s*[:.]\s*/i, "$1");
            wrap.insertBefore(cap, table);
            next.remove();
        }

        // numeric columns: mark when every body cell in the column parses as a number
        const rows = Array.from(table.tBodies[0]?.rows || []);
        const headCells = Array.from(table.tHead?.rows[0]?.cells || table.rows[0]?.cells || []);
        headCells.forEach((th, i) => {
            const cells = rows.map((r) => r.cells[i]).filter(Boolean);
            if (cells.length && cells.every((c) => numeric(c.textContent))) {
                th.setAttribute("data-num", "");
                cells.forEach((c) => c.setAttribute("data-num", ""));
            }
        });

        // sorting: opt in with data-sortable on the table, or automatically for 6+ rows
        const sortable = table.hasAttribute("data-sortable") || rows.length >= 6;
        if (!sortable || !table.tHead || !rows.length) return;

        headCells.forEach((th, i) => {
            th.setAttribute("aria-sort", "none");
            th.setAttribute("tabindex", "0");
            th.setAttribute("role", "columnheader");
            th.insertAdjacentHTML("beforeend", SORT_ICON);
            const sort = () => {
                const current = th.getAttribute("aria-sort");
                const dir = current === "ascending" ? "descending" : "ascending";
                headCells.forEach((h) => h.setAttribute("aria-sort", "none"));
                th.setAttribute("aria-sort", dir);
                const isNum = th.hasAttribute("data-num");
                const sorted = rows.slice().sort((a, b) => {
                    const av = a.cells[i]?.textContent.trim() ?? "";
                    const bv = b.cells[i]?.textContent.trim() ?? "";
                    const cmp = isNum ? toNumber(av) - toNumber(bv) : av.localeCompare(bv, undefined, { numeric: true });
                    return dir === "ascending" ? cmp : -cmp;
                });
                sorted.forEach((r) => table.tBodies[0].appendChild(r));
            };
            th.addEventListener("click", sort);
            th.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") { e.preventDefault(); sort(); }
            });
        });
    });
}
